import { FC, SVGProps } from 'react';

const DashboardIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#7A7A7A', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M14.8997 16.5871C16.4922 15.2136 17.5 13.1833 17.5 10.9146C17.5 6.7682 14.1433 3.41144 9.99675 3.41144C5.85757 3.41144 2.5 6.7682 2.5 10.9146C2.5 13.1833 3.50865 15.2136 5.10108 16.5871"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M13.2017 7.72461L11.1674 9.75892M11.6411 10.9135C11.6411 11.8208 10.9057 12.5554 9.99836 12.5554C9.09186 12.5554 8.35645 11.8208 8.35645 10.9135C8.35645 10.0063 9.09186 9.27083 9.99836 9.27083C10.9057 9.27083 11.6411 10.0063 11.6411 10.9135Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default DashboardIcon;
